/*
 * Vezba – accessibility helpers (keyboard & screen readers)
 * 1. <drawer-close-button> elements become real buttons (focusable, Enter/Space, label "Затвори").
 * 2. When the cart drawer opens, keyboard focus moves into it, Tab stays inside,
 *    Escape closes it and focus returns to where it was.
 */
(function () {
  var labels = window.vezbaA11y || {};
  var CLOSE = labels.close || 'Затвори';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function isVisible(el) {
    if (!el.getClientRects().length) return false;
    var s = window.getComputedStyle(el);
    return s.visibility !== 'hidden' && s.display !== 'none';
  }

  function enhanceCloseButtons(root) {
    (root || document).querySelectorAll('drawer-close-button:not([data-a11y])').forEach(function (btn) {
      btn.setAttribute('data-a11y', '1');
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', CLOSE);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });
  }

  function setupDrawer(details, labelSelector, label) {
    if (!details || details.dataset.a11y) return;
    details.dataset.a11y = '1';
    var lastFocus = null;
    var wasOpen = false;

    function isOpen() {
      return details.hasAttribute('open') && details.classList.contains('menu-opening');
    }

    // Everything inside the drawer except its <summary> (the cart icon that opens it)
    function inPanel(el) {
      return !!el && details.contains(el) && el.tagName !== 'SUMMARY' && !el.closest('summary');
    }

    function focusables() {
      return Array.prototype.filter.call(details.querySelectorAll(FOCUSABLE), function (el) {
        return inPanel(el) && isVisible(el);
      });
    }

    function labelPanel() {
      var panel = details.querySelector(labelSelector);
      if (!panel) return;
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      if (label) panel.setAttribute('aria-label', label);
    }
    labelPanel();

    function closeButton() {
      var buttons = details.querySelectorAll('drawer-close-button');
      for (var i = 0; i < buttons.length; i++) {
        if (isVisible(buttons[i])) return buttons[i];
      }
      return buttons[0] || null;
    }

    function focusInside() {
      if (!isOpen() || inPanel(document.activeElement)) return;
      enhanceCloseButtons(details);
      labelPanel();
      var target = closeButton() || focusables()[0];
      if (target) target.focus();
    }

    function onChange() {
      var open = isOpen();
      if (open === wasOpen) return;
      wasOpen = open;
      if (open) {
        if (!inPanel(document.activeElement)) lastFocus = document.activeElement;
        [300, 800, 1500, 2500].forEach(function (ms) { setTimeout(focusInside, ms); });
      } else if (lastFocus && document.contains(lastFocus)) {
        var back = lastFocus;
        lastFocus = null;
        setTimeout(function () { back.focus(); }, 50);
      }
    }

    new MutationObserver(onChange).observe(details, { attributes: true, attributeFilter: ['open', 'class'] });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        var close = closeButton();
        if (close) {
          e.preventDefault();
          close.click();
        }
        return;
      }
      if (e.key === 'Tab') {
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (!inPanel(document.activeElement)) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }, true);
  }

  function init() {
    enhanceCloseButtons(document);
    new MutationObserver(function () { enhanceCloseButtons(document); }).observe(document.body, { childList: true, subtree: true });
    setupDrawer(document.querySelector('details.cart-drawer-container'), 'mini-cart', labels.cart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
